module.exports = __webpack_public_path__ + "static/img/2.7748b85.png";


//////////////////
// WEBPACK FOOTER
// ./static/ALL/2.png
// module id = qUq1
// module chunks = 202